module.exports = __webpack_public_path__ + "media/images/tiedye/inspiration-2329bb2382b96cf7ef05595f4688c108.jpg";